const faqs = [
  {
    question: "Does Maryland have its own regional passport agency?",
    answer:
      "Maryland does not have a state-level passport agency. The nearest regional passport agency for most Maryland travelers is the Washington DC Passport Agency, located at 600 19th St NW. Eastern Shore residents may find the Philadelphia Passport Agency at 200 Chestnut St more convenient. Both require proof of travel within 14 days and a scheduled appointment.",
  },
  {
    question: "How fast can I get a passport in Maryland?",
    answer:
      "With Fast Passport Center's courier service, Maryland travelers can receive a passport in as little as 24 hours. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks.",
  },
  {
    question: "Do I need to visit a passport acceptance facility in Maryland?",
    answer:
      "First-time applicants, minors, and those replacing lost or stolen passports must visit an acceptance facility (typically a post office, county clerk, or library). Renewals for adults can usually be done by mail without an in-person visit. Maryland has acceptance facilities in every county.",
  },
  {
    question: "Which Maryland airport should I fly from with an expired passport?",
    answer:
      "If your passport is expired or soon to expire, you should not book international travel until you have a valid passport in hand. Major Maryland-area international airports include BWI (Baltimore-Washington), Reagan National (DCA), and Dulles International (IAD). Salisbury-Ocean City (SBY) also offers seasonal international connections.",
  },
  {
    question: "Can I renew by mail from Maryland?",
    answer:
      "Yes, if your most recent passport was issued within the last 15 years, when you were age 16 or older, and it is undamaged and in your current name (or you have legal documentation of a name change). Otherwise, you will need to apply in person at an acceptance facility.",
  },
  {
    question: "Where is the best place to get a passport photo in Maryland?",
    answer:
      "CVS, Walgreens, and UPS Store locations are widely available throughout Maryland and typically offer walk-in passport photo service. The UPS Store and FedEx Office can also handle overnight shipping of your documents. Always verify that photos meet the 2×2 inch white background requirement.",
  },
];

export { faqs };

export default function MarylandFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Maryland Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across the state of Maryland.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-white rounded-lg border border-gray-200 overflow-hidden"
            >
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}